import FeaturedAuthorSection from './featuredAuthorSection'

export default FeaturedAuthorSection
